import { render, staticRenderFns } from "./payment-failed-form.vue?vue&type=template&id=b4b1d834&"
import script from "./payment-failed-form.vue?vue&type=script&lang=js&"
export * from "./payment-failed-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports